import { useEffect, useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export interface BookingComment {
  id: number;
  booking_id: number;
  comment_type: number;
  description: string;
  created_at: string;
  comment_types: {
    id: number;
    name: string;
  };
}

export const useBookingComments = (bookingId: number) => {
  const [comments, setComments] = useState<BookingComment[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchComments = useCallback(async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from("booking_comment")
        .select(`
          id,
          booking_id,
          comment_type,
          description,
          created_at,
          comment_types!comments_comment_type_fkey (
            id,
            name
          )
        `)
        .eq("booking_id", bookingId)
        .order("created_at", { ascending: false });

      if (error) throw error;
      setComments(data || []);
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setLoading(false);
    }
  }, [bookingId]);

  useEffect(() => {
    if (bookingId) {
      fetchComments();
    }
  }, [bookingId, fetchComments]);

  return { comments, loading, error };
}; 